import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { HttpService } from '@services/index';
import { EndpointParams } from '@models/utils/endpoint-params';
import { MemberBillingInfo } from '@models/index';

@Injectable({
    providedIn: 'root'
})
export class MemberBillingInfoService extends HttpService {
    private readonly defaultEndpointParams: EndpointParams = { app: 'payments', version: 1 };

    search(): Observable<MemberBillingInfo> {
        return this.get('customer/billing-info', this.defaultEndpointParams);
    }
}
